module.exports = __webpack_public_path__ + "media/images/firsttime_header02_pc-da6542c2675aee29a59f972eedefd2e6.png";